import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './../store';
import Auth from '../shell/components/Auth';

class MainPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: null
        };
    }

    updateToken = (fullToken) => {
        if (fullToken !== undefined && fullToken !== null) {
            this.setState({ token: fullToken });
        }
    };

    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <Auth
                        onUpdateToken={this.updateToken}
                        token={this.state.token}
                    />
                </PersistGate>
            </Provider>
        );
    }
}

export default MainPage;
